import { css, html, LitElement, nothing } from 'lit'
import { property } from 'lit/decorators.js'
import { safeCustomElement } from '@/utilities/custom-element'
import type { HeaderDropdownItemGroup } from './types'

@safeCustomElement('mdc-header-dropdown')
export class MdcHeaderDropdown extends LitElement {
  @property({ type: Array }) itemGroups: HeaderDropdownItemGroup[] = []

  static styles = css`
		:host {
			display: block;
			font-family: var(--typography-font-family-sans);
		}

		.mdc-header-dropdown {
			background: var(--color-functional-gray-white, #ffffff);
			list-style: none;
			padding: 0;
			margin: 0;
			width: 17.5rem;
			display: flex;
			flex-direction: column;
			justify-content: flex-start;
			align-items: flex-start;
			border-radius: 0.5rem;
			border: 1px solid var(--color-functional-gray-200, #e5e5e5);
			box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.12);
			overflow: hidden;
		}

		.mdc-header-dropdown__item-group {
			width: 100%;
			display: flex;
			flex-direction: column;
			justify-content: flex-start;
			align-items: flex-start;
			padding: 0.5rem 0;
			border-bottom: 1px solid var(--color-functional-gray-200, #e5e5e5);
		}

		.mdc-header-dropdown__item-group:last-child {
			border-bottom: none;
		}

		.mdc-header-dropdown__item {
			width: 100%;
			padding: 0.5rem 1rem;
		}

		.mdc-header-dropdown__title {
			color: var(--color-functional-gray-400, #999999);
			font-size: 0.75rem;
			font-style: normal;
			font-weight: 450;
			line-height: 120%;
			padding: 0.5rem 1rem;
			width: 100%;
			box-sizing: border-box;
		}

		.mdc-header-dropdown__title--status {
			display: flex;
			align-items: center;
			justify-content: space-between;
		}

		.mdc-header-dropdown__title-status {
			text-transform: uppercase;
			display: flex;
			padding: 0.3125rem 0.5rem;
			justify-content: center;
			align-items: center;
			border-radius: 0.25rem;
			border: 1px solid var(--color-functional-gray-400, #999999);
			color: var(--color-functional-gray-400, #999999);
			line-height: 100%;
			font-size: 0.625rem;
		}

		.mdc-header-dropdown__title-status--pro {
			color: var(--color-functional-amber, #ffb800);
			border-color: var(--color-functional-amber, #ffb800);
		}
	`

  render() {
    return html`
			<ul class="mdc-header-dropdown">
				${this.itemGroups?.map(
          (group, index) => html`
						<li class="mdc-header-dropdown__item-group">
							${
                group.title
                  ? html`
										<div class="mdc-header-dropdown__title ${group.titleStatus ? 'mdc-header-dropdown__title--status' : ''}">
											${group.title}
											${
                        group.titleStatus
                          ? html`
														<span class="mdc-header-dropdown__title-status ${group.titleStatus?.toLowerCase() === 'pro' ? 'mdc-header-dropdown__title-status--pro' : ''}">
															${group.titleStatus}
														</span>
													`
                          : nothing
                      }
										</div>
									`
                  : nothing
              }
							${group.items.map(
                (item, itemIndex) => html`
									<div class="mdc-header-dropdown__item">
										<slot name="item-${index}-${itemIndex}">${item}</slot>
									</div>
								`
              )}
						</li>
					`
        )}
				<slot></slot>
			</ul>
		`
  }
}
